var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          dense: true,
          title: "Resumen del Documento",
          breadcrumbs: _vm.breadcrumbs,
          breadcrumbsItemDinamic: {
            loading: _vm.$store.state.purchases.retrieveLoader,
            text: `${(_vm.activeDocument || {}).name} Nº ${
              _vm.instance.number
            }`,
          },
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.retrieve },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { disabled: !_vm.instance?.email_id, outlined: "" },
                    on: {
                      click: function ($event) {
                        _vm.modalEmail = true
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-eye")]),
                    _vm._v("Ver email"),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled: _vm.$store.state.purchases.retrieveLoader,
                      outlined: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.downloadFile2(
                          "purchases",
                          `${_vm.instance.type}_N${_vm.instance.number}`,
                          "rec-docs",
                          "xml",
                          _vm.instance.id
                        )
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-download"),
                    ]),
                    _vm._v("Descargar documento"),
                  ],
                  1
                ),
                _vm.instance?.status === "APR"
                  ? [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            outlined: "",
                            ripple: false,
                            disabled: _vm.isAcceptDisabled,
                          },
                          on: { click: _vm.handleAcceptClick },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-document-check"),
                          ]),
                          _vm._v(" Aceptar "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            color: "grey-900",
                            ripple: false,
                            disabled: _vm.isRejectDisabled,
                          },
                          on: { click: _vm.handleRejectClick },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-file-document-remove"),
                          ]),
                          _vm._v(" Rechazar "),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0", staticStyle: { "z-index": "0" } },
        [
          _vm.$store.state.purchases.retrieveLoader
            ? _c("skeleton-detail")
            : _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "mr-6 mt-n1",
                    staticStyle: { "min-width": "400px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "fixed!important" } },
                      [
                        _c(
                          "v-img",
                          {
                            attrs: {
                              contain: "",
                              width: 400,
                              height: 110,
                              src: require(`@/assets/backgrounds/background-document-detail.svg`),
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate",
                                staticStyle: { "max-width": "400px" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("nameDocumentsType")(
                                        _vm.instance.type
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ml-2 mt-3",
                                attrs: { align: "end", "no-gutters": "" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "4" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Total")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  _vm.documentCurrency,
                                                  _vm.instance.amount_total
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Fecha")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  _vm.instance.date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        (_vm.instance.assignee_tax_id ||
                          _vm.instance.assignment_agency_status) &&
                        _vm.$store?.state?.auth?.account?.country === "CL"
                          ? _c(
                              "v-card",
                              {
                                staticClass: "mt-4 py-3",
                                staticStyle: {
                                  "border-color": "var(--grey-900)",
                                },
                                attrs: { color: "green-50", outlined: "" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "px-5",
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "18",
                                          color: "grey-900",
                                        },
                                      },
                                      [_vm._v("mdi-file-arrow-left-right")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 grey-900--text font-weight-bold",
                                      },
                                      [_vm._v("Información de cesión")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "px-5 mt-2",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-block body-1 grey-900--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.instance.assignee_name ||
                                                "Sin definir"
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-900--text font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatRut(
                                                _vm.instance.assignee_tax_id
                                              ) || "Sin definir"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0 text-right" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-block body-1 grey-900--text",
                                          },
                                          [_vm._v("Fecha de cesión")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-900--text font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateTimeSecond")(
                                                  _vm.instance.assignment_date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-0 mt-4",
                            staticStyle: { position: "fixed!important" },
                            attrs: {
                              width: "400",
                              transition: "slide-y-transition",
                              "min-height": _vm.instance.assignee_tax_id
                                ? "calc(100% - 585px)"
                                : "calc(100% - 278px)",
                              flat: "",
                            },
                          },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 subtitle-2 grey-500--text font-weight-bold",
                                  },
                                  [_vm._v("Resumen del documento")]
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c(
                              "div",
                              { staticClass: "py-4 px-5" },
                              [
                                _c(
                                  "v-list",
                                  {
                                    staticClass:
                                      "v-list-form-main transparent pa-0",
                                  },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("Razón Social")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "body-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.instance || {})
                                                  .supplier_name
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("generals.RUT"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "body-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatRutChile(
                                                  (_vm.instance || {}).tax_id
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("Tipo de documento")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "body-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("nameDocumentsType")(
                                                  _vm.instance.type
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.instance.status !== "draft"
                                      ? _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("generals.Folio #")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.instance.number)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("ID")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  color: "grey-background",
                                                  right: "",
                                                  transition:
                                                    "scale-transition",
                                                  "max-width": "320",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "grey-300--text",
                                                              staticStyle: {
                                                                "justify-content":
                                                                  "left",
                                                              },
                                                              attrs: {
                                                                text: "",
                                                                ripple: false,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toClipboard(
                                                                      _vm
                                                                        .instance
                                                                        .id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.instance.id
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-block px-3 py-2",
                                                  },
                                                  [_vm._v("Copiar")]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.paymentMethod
                                      ? _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Forma de pago")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.paymentMethod)
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "pa-0" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("Creado el")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "body-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateTimeSecond")(
                                                  _vm.instance.created
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pb-5",
                    staticStyle: { flex: "1", "min-width": "180px" },
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "mb-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-bold",
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-n1 subtitle-2 grey-700--text font-weight-semibold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2 mt-n1",
                                              attrs: {
                                                small: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-shield-check")]
                                          ),
                                          _vm._v("Cumplimiento "),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-card-text",
                          { staticClass: "px-0 py-4" },
                          [
                            _vm.loadingSwap
                              ? _c("v-skeleton-loader", {
                                  staticClass: "rounded-md",
                                  attrs: { type: "list-item-three-line" },
                                })
                              : _c(
                                  "v-list",
                                  {
                                    staticClass:
                                      "v-list-form-2-actions transparent pa-0",
                                    attrs: { width: "100%" },
                                  },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [_vm._v("Estado comercial")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          [
                                            _c("chip-status", {
                                              attrs: {
                                                status:
                                                  _vm.instance?.rec_status ||
                                                  "PEN",
                                                detail: _vm.instance
                                                  ?.rec_status_info
                                                  ? _vm.instance
                                                      ?.rec_status_info
                                                  : null,
                                                showDetail: true,
                                                type: "purchases",
                                                isTooltip: true,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-5" }),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          },
                                          [
                                            _vm._v(
                                              "Estado " +
                                                _vm._s(_vm.$t("generals.SII"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          [
                                            _c("chip-status", {
                                              attrs: {
                                                status: _vm.instance?.status,
                                                showDetail: true,
                                                type: "documents",
                                                isTooltip: false,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-action",
                                          {
                                            staticClass: "ma-0",
                                            staticStyle: { overflow: "hidden" },
                                          },
                                          [
                                            [
                                              "FAI",
                                              "SNT",
                                              "CRE",
                                              "ART",
                                              "MRT",
                                            ].includes(_vm.instance?.status)
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "btnText",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledUpdate,
                                                      text: "",
                                                      color: "grey-900",
                                                      ripple: false,
                                                    },
                                                    on: {
                                                      click: _vm.reprocessDoc,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          left: "",
                                                          color: "grey-900",
                                                        },
                                                      },
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                    _vm._v(
                                                      " Actualizar estado "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    ![
                                      "FAI",
                                      "SNT",
                                      "CRE",
                                      "ART",
                                      "MRT",
                                    ].includes(_vm.instance?.status)
                                      ? _c(
                                          "v-list-item",
                                          { staticClass: "px-5" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Fecha de validación")]
                                            ),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("dateTimeSecond")(
                                                      _vm.instance
                                                        .validation_date
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panels",
                      {
                        model: {
                          value: _vm.panelTotals,
                          callback: function ($$v) {
                            _vm.panelTotals = $$v
                          },
                          expression: "panelTotals",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "px-5 py-4" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-n1 subtitle-2 grey-700--text font-weight-semibold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2 mt-n1",
                                              attrs: {
                                                small: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-currency-usd")]
                                          ),
                                          _vm._v("Detalle"),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm.panelTotals !== 0
                                      ? _c(
                                          "v-col",
                                          {
                                            staticClass: "text-right mr-2 pa-0",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block grey-700--text body-1 font-weight-medium",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance.amount_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "px-0 pb-4" },
                              [
                                _c(
                                  "v-list",
                                  { staticClass: "transparent pa-0" },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "subtitle-2" },
                                          [_vm._v("Subtotal")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "text-right font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  _vm.documentCurrency,
                                                  _vm.instance.amount_subtotal
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "subtitle-2" },
                                          [_vm._v("Descuento")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "text-right grey-500--text font-weight-bold",
                                          },
                                          [
                                            _vm.instance.amount_discount
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$fmt.currency(
                                                        _vm.documentCurrency,
                                                        _vm.instance
                                                          .amount_discount
                                                      )
                                                    )
                                                  ),
                                                ]
                                              : [_vm._v("-")],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    (_vm.activeDocument || {}).has_taxes_detail
                                      ? [
                                          _c("v-divider", {
                                            staticClass: "my-1",
                                          }),
                                          _c(
                                            "v-list-item",
                                            { staticClass: "px-5" },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "subtitle-2" },
                                                [_vm._v("Exento")]
                                              ),
                                              _vm.instance.amount_exempt
                                                ? _c(
                                                    "v-list-item-subtitle",
                                                    {
                                                      staticClass:
                                                        "text-right grey-500--text font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$fmt.currency(
                                                            _vm.documentCurrency,
                                                            _vm.instance
                                                              .amount_exempt
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : [_vm._v("-")],
                                            ],
                                            2
                                          ),
                                          _vm.activeDocument.has_taxes
                                            ? [
                                                _c(
                                                  "v-list-item",
                                                  { staticClass: "px-5" },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "subtitle-2",
                                                      },
                                                      [_vm._v("Neto")]
                                                    ),
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "text-right grey-500--text font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$fmt.currency(
                                                              _vm.documentCurrency,
                                                              _vm.instance
                                                                .amount_net
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c("v-divider", {
                                                  staticClass: "my-1",
                                                }),
                                                _c(
                                                  "v-list-item",
                                                  { staticClass: "px-5" },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "subtitle-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Impuestos (" +
                                                            _vm._s(
                                                              _vm.activeDocument
                                                                .tax_percent
                                                            ) +
                                                            "%)"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "text-right grey-500--text font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$fmt.currency(
                                                              _vm.documentCurrency,
                                                              _vm.instance
                                                                .amount_tax
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _c("v-divider", { staticClass: "my-1" }),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "px-5" },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass:
                                              "body-1 grey-500--text font-weight-bold",
                                          },
                                          [_vm._v("Total documento")]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "text-right body-1 grey-500--text font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$fmt.currency(
                                                  _vm.documentCurrency,
                                                  _vm.instance.amount_total
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panels",
                      {
                        staticClass: "mt-5",
                        model: {
                          value: _vm.panelPDF,
                          callback: function ($$v) {
                            _vm.panelPDF = $$v
                          },
                          expression: "panelPDF",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "px-5 py-4" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-semibold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                small: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [_vm._v("mdi-text-box")]
                                          ),
                                          _vm._v("Visualizar PDF"),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              {
                                staticClass: "px-0",
                                staticStyle: { "min-height": "300px" },
                              },
                              [
                                _c("render-pdf", {
                                  attrs: {
                                    basicRender: true,
                                    documentType: _vm._f("nameDocumentsType")(
                                      (_vm.instance || {}).type || ""
                                    ),
                                    number: _vm.instance.number,
                                    loaderRender: _vm.loaderRender,
                                    renderUrl: _vm.renderUrl,
                                    flat: true,
                                    showToolbar: false,
                                    showFormat: true,
                                  },
                                  on: {
                                    close: function ($event) {
                                      _vm.modalPDF = false
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panels",
                      {
                        staticClass: "mt-5",
                        model: {
                          value: _vm.panelRelatedDocuments,
                          callback: function ($$v) {
                            _vm.panelRelatedDocuments = $$v
                          },
                          expression: "panelRelatedDocuments",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "px-4 py-3" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "18",
                                              left: "",
                                              color: "grey-700",
                                            },
                                          },
                                          [_vm._v("mdi-file-document-multiple")]
                                        ),
                                        _vm._v("Referencias"),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "px-0" },
                              [
                                !_vm.references?.length
                                  ? _c("v-empty-state", {
                                      staticClass: "mt-n2 pb-2",
                                      attrs: {
                                        type: "documents",
                                        id: "documentos",
                                        customClass: "mt-1",
                                        isFree: true,
                                        title:
                                          "No hay información de referencias",
                                        height: 199,
                                      },
                                    })
                                  : _c("v-simple-table", {
                                      staticClass:
                                        "px-0 no-hover table-not-rounded",
                                      attrs: { dense: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c(
                                                "thead",
                                                [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "180px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "120px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "generals.Folio"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "70px",
                                                        },
                                                      },
                                                      [_vm._v("Fecha del doc.")]
                                                    ),
                                                  ]),
                                                  _c("v-divider", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      "margin-top": "-10px",
                                                      "min-width": "100%",
                                                      "margin-left": "-1px",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.references,
                                                  function (item) {
                                                    return _c(
                                                      "tr",
                                                      {
                                                        key: item.number,
                                                        style:
                                                          _vm.isReferenceClickable(
                                                            item
                                                          )
                                                            ? "cursor: pointer"
                                                            : "",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.isReferenceClickable(
                                                              item
                                                            ) &&
                                                              _vm.$router.push({
                                                                name: "PurchaseList",
                                                                params:
                                                                  _vm.$route
                                                                    .params,
                                                                query: {
                                                                  type: item.type,
                                                                  series:
                                                                    item.series,
                                                                  serial:
                                                                    item.serial,
                                                                  _name:
                                                                    _vm.instance
                                                                      .number,
                                                                },
                                                              })
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "body-2",
                                                          },
                                                          [
                                                            item.type
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline-block text-truncate",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "99%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "nameReferencesType"
                                                                          )(
                                                                            item.type
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "body-2 text--disabled font-italic",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Sin especificar"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-right body-2",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.number
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-right body-2",
                                                          },
                                                          [
                                                            item.date
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "date"
                                                                      )(
                                                                        item.date
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card",
                      { staticClass: "mt-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-timeline-clock")]
                                ),
                                _vm._v("Eventos"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.eventLoading
                          ? _c("v-skeleton-loader", {
                              staticClass: "mb-2 panel px-1 rounded-md",
                              attrs: {
                                transition: "fade-transition",
                                type: "list",
                              },
                            })
                          : (_vm.eventsList || []).length
                          ? [
                              _c("v-divider"),
                              _c(
                                "v-card-text",
                                { staticClass: "pa-0" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "transparent px-0 py-2 dense",
                                    },
                                    [
                                      _vm._l(_vm.events, function (d, i) {
                                        return _c(
                                          "div",
                                          { key: i },
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                key: i,
                                                staticClass: "px-5 py-0",
                                              },
                                              [
                                                _c(
                                                  "v-list-item-icon",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "grey-900",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentEvent(
                                                              d.rec_event_type
                                                            ).icon
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item-title",
                                                  { staticClass: "ml-n5" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-flex grey-700--text body-1",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-medium",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.currentEvent(
                                                                  d.rec_event_type
                                                                ).summary
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        d.description
                                                          ? [
                                                              _c("v-divider", {
                                                                staticClass:
                                                                  "mx-2 my-1",
                                                                attrs: {
                                                                  vertical: "",
                                                                },
                                                              }),
                                                              d.description
                                                                .length < 30
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-body-2 grey-700--text",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-top":
                                                                            "2px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          d.description
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-background",
                                                                        right:
                                                                          "",
                                                                        transition:
                                                                          "scale-transition",
                                                                        width:
                                                                          "500",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-sheet",
                                                                                    _vm._g(
                                                                                      {
                                                                                        staticClass:
                                                                                          "grey-700--text",
                                                                                        attrs:
                                                                                          {
                                                                                            width:
                                                                                              "100%",
                                                                                            height:
                                                                                              "20",
                                                                                          },
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-inline-block text-truncate text-body-2",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "max-width":
                                                                                                "90%",
                                                                                              "margin-top":
                                                                                                "2px",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                d.description
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "d-block px-3 py-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              d.description
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block body-2 grey-300--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(d.created)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            i !== _vm.eventsList.length - 1
                                              ? _c(
                                                  "v-sheet",
                                                  {
                                                    staticClass:
                                                      "text-left ml-8 mt-n4 mb-n2",
                                                    attrs: { height: "18" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          left: "30px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                    _c("v-divider", {
                                                      staticClass: "my-0",
                                                      attrs: { vertical: "" },
                                                    }),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mb-n1",
                                                        staticStyle: {
                                                          left: "-1px",
                                                          top: "7px",
                                                        },
                                                        attrs: {
                                                          size: "3",
                                                          color: "placeholder",
                                                        },
                                                      },
                                                      [_vm._v("mdi-circle")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }),
                                      _vm.eventsList.length > 3
                                        ? [
                                            _c("v-divider", {
                                              staticClass: "mt-4",
                                            }),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mt-1 mb-n1 mx-5",
                                                attrs: {
                                                  color: "grey-900",
                                                  text: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showMoreEvents =
                                                      !_vm.showMoreEvents
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !_vm.showMoreEvents
                                                        ? "Ver todos los eventos"
                                                        : "Ver menos eventos"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogCL,
            callback: function ($$v) {
              _vm.dialogCL = $$v
            },
            expression: "dialogCL",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.dialogCLType === "accept"
                                ? "Aceptar"
                                : "Rechazar"
                            ) + " documento"
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.closeCLDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "4" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/${
                              _vm.dialogCLType === "accept"
                                ? "modal-cl-accept"
                                : "modal-cl-claim"
                            }.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "v-list",
                            { staticClass: "v-list-form pa-0 transparent" },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0 mb-3" },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticClass:
                                            "inf-alert-blue green-500--text rounded-md mb-3",
                                          attrs: {
                                            height:
                                              _vm.dialogCLType === "accept"
                                                ? 88
                                                : 58,
                                            dense: "",
                                            text: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "d-flex pa-0" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: "green-500",
                                                    size: "22",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-information-outline"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ml-4 text-description",
                                                },
                                                [
                                                  _vm.dialogCLType === "accept"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Al aceptar un documento en el SII, entrega acuse de recibo de mercaderías y/o servicios, y pasa a formar parte de propuesta de pago de IVA. "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Al rechazar un documento en el SII, quedará fuera de la propuesta de pago de IVA. "
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.dialogCLType === "accept"
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "mt-n4 d-block grey-500--text font-weight-semibold body-1",
                                  },
                                  [_vm._v("Acuse de recibo del documento")]
                                ),
                                _c(
                                  "v-list-item",
                                  { staticClass: "pa-0 mt-n1" },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            placeholder: "Recinto",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.acceptRecinto,
                                            callback: function ($$v) {
                                              _vm.acceptRecinto = $$v
                                            },
                                            expression: "acceptRecinto",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "mt-n4 d-block grey-500--text font-weight-semibold body-1",
                                  },
                                  [
                                    _vm._v(
                                      "Selecciona la respuesta al documento"
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-list-item",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            items: _vm.claimTypes,
                                            "item-text": "label",
                                            "item-value": "value",
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            placeholder: "Seleccione motivo",
                                          },
                                          model: {
                                            value: _vm.claimType,
                                            callback: function ($$v) {
                                              _vm.claimType = $$v
                                            },
                                            expression: "claimType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      { staticClass: "pt-0 mt-0" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            placeholder: "Motivo de rechazo",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.claimReason,
                                            callback: function ($$v) {
                                              _vm.claimReason = $$v
                                            },
                                            expression: "claimReason",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: { click: _vm.closeCLDialog },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled:
                          _vm.dialogCLType === "accept"
                            ? !_vm.acceptRecinto
                            : !_vm.claimType || !_vm.claimReason,
                        loading: _vm.loadingSwap,
                        ripple: false,
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialogCLType === "accept"
                            ? _vm.acceptDocumentCL()
                            : _vm.claimDocumentCL()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dialogCLType === "accept"
                              ? "Aceptar"
                              : "Rechazar"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
            scrollable: "",
          },
          model: {
            value: _vm.modalEmail,
            callback: function ($$v) {
              _vm.modalEmail = $$v
            },
            expression: "modalEmail",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Email")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.modalEmail = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0" },
                    [
                      _vm.loadingEmail
                        ? _c("v-skeleton-loader", {
                            staticClass: "rounded-md mx-5",
                            attrs: { type: "list-item-three-line, image" },
                          })
                        : [
                            !!_vm.instance?.email_id && _vm.errorEmail
                              ? _c("v-empty-state", {
                                  staticClass: "mt-8 mb-3",
                                  attrs: {
                                    type: "email",
                                    id: "email",
                                    customClass: "mt-5",
                                    isFree: true,
                                    title: "Email no disponible",
                                    height: 160,
                                  },
                                })
                              : _c(
                                  "v-card",
                                  {
                                    staticClass: "transparent rounded-0 pa-0",
                                    attrs: { flat: "" },
                                  },
                                  [
                                    _c(
                                      "v-card-subtitle",
                                      {
                                        staticClass:
                                          "background pt-5 pb-3 px-5",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey-500--text body-1",
                                                staticStyle: {
                                                  "min-width": "120px",
                                                },
                                              },
                                              [_vm._v("De")]
                                            ),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                required: "",
                                                "single-line": "",
                                                dense: "",
                                                readonly: "",
                                                "persistent-hint": "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: _vm.messages.recipient,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.messages,
                                                    "recipient",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "messages.recipient",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center mt-3",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey-500--text body-1",
                                                staticStyle: {
                                                  "min-width": "120px",
                                                },
                                              },
                                              [_vm._v("Asunto")]
                                            ),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                required: "",
                                                "single-line": "",
                                                dense: "",
                                                readonly: "",
                                                maxlength: "60",
                                                "persistent-hint": "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: _vm.messages.subject,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.messages,
                                                    "subject",
                                                    $$v
                                                  )
                                                },
                                                expression: "messages.subject",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm.messages.date
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center mt-4",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "grey-500--text body-1",
                                                    staticStyle: {
                                                      "min-width": "120px",
                                                    },
                                                  },
                                                  [_vm._v("Fecha de envío")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "grey-300--text body-1",
                                                    staticStyle: {
                                                      "min-width": "120px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateTimeSecond"
                                                        )(_vm.messages.date)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-0 mt-5",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey-500--text body-1 mr-5 mb-3 d-block",
                                              },
                                              [_vm._v("Archivos adjuntos")]
                                            ),
                                            _c(
                                              "v-row",
                                              { staticClass: "px-1" },
                                              _vm._l(
                                                _vm.messages.files,
                                                function (file) {
                                                  return _c(
                                                    "v-col",
                                                    {
                                                      key: file.index,
                                                      staticClass: "px-2 py-1",
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "px-2 py-0 my-1",
                                                          attrs: {
                                                            flat: "",
                                                            rounded: "sm",
                                                            height: 44,
                                                            outlined: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.downloadFileEmail(
                                                                file
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0 d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-icon",
                                                                {
                                                                  staticClass:
                                                                    "mb-0 mt-2 ml-0 mr-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "grey-700",
                                                                        size: "28",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-paperclip"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-subtitle",
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "caption grey-500--text d-inline-block text-truncate",
                                                                      class:
                                                                        !file.size
                                                                          ? "mt-2"
                                                                          : "mt-1",
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "98%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          file.file_name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  file.size
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "mt-n4 d-block grey-300--text overline d-block",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              file.size
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              text: "",
                                              color: "grey-900",
                                            },
                                            on: {
                                              click: _vm.downloadAllEmails,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v("mdi-download")]
                                            ),
                                            _vm._v("Descargar todos"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c(
                                      "v-col",
                                      { staticClass: "px-0 pt-5 ml-n1 pb-0" },
                                      [
                                        _c("v-textarea", {
                                          staticClass: "elevation-0",
                                          attrs: {
                                            readonly: "",
                                            "auto-grow": "",
                                            solo: "",
                                            flat: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: _vm.messages.text,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.messages,
                                                "text",
                                                $$v
                                              )
                                            },
                                            expression: "messages.text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                    ],
                    2
                  ),
                  _c("v-col"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogGrant,
            callback: function ($$v) {
              _vm.dialogGrant = $$v
            },
            expression: "dialogGrant",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Ceder documento")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogGrant = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass:
                                "v-list-form-extended transparent pa-0",
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "px-5 pt-0" },
                                [
                                  _c("v-list-item-title", [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Cedida a")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "dni",
                                                rawName: "v-dni",
                                                value: "CL",
                                                expression: "'CL'",
                                              },
                                            ],
                                            attrs: {
                                              error:
                                                _vm.$v.grant.assigneeTaxId
                                                  .$error,
                                              outlined: "",
                                              "hide-details": "",
                                              required: "",
                                              "single-line": "",
                                              dense: "",
                                              maxlength: "32",
                                            },
                                            model: {
                                              value:
                                                _vm.$v.grant.assigneeTaxId
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.grant.assigneeTaxId,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.grant.assigneeTaxId.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeName.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "100",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeName.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeName.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Email")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeEmail.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeEmail.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeEmail,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeEmail.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Dirección"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeAddress.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeAddress.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeAddress,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeAddress.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "my-3" }),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Cedida por")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "pt-2 pb-1 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Email")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assignorEmail.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assignorEmail.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assignorEmail,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assignorEmail.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assignorName.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "100",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assignorName.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assignorName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assignorName.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "dni",
                                                rawName: "v-dni",
                                                value: "CL",
                                                expression: "'CL'",
                                              },
                                            ],
                                            attrs: {
                                              error:
                                                _vm.$v.grant.assignorTaxId
                                                  .$error,
                                              outlined: "",
                                              "hide-details": "",
                                              required: "",
                                              "single-line": "",
                                              dense: "",
                                              maxlength: "70",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.$v.grant.assignorTaxId
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.grant.assignorTaxId,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.grant.assignorTaxId.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogGrant = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.createGrant },
                    },
                    [_vm._v("Ceder documento")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "590",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogLoadingAssign,
            callback: function ($$v) {
              _vm.dialogLoadingAssign = $$v
            },
            expression: "dialogLoadingAssign",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "px-6 py-6" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pr-0", attrs: { cols: "2" } },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "grey-900",
                              width: 8,
                              size: "48",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { staticClass: "pl-0" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-block body-1 font-weight-bold pt-2 text-grey-700--text",
                          },
                          [_vm._v("Procesando tu solicitud...")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-block body-2 mt-1 text-grey-500--text",
                          },
                          [_vm._v("La cesión del documento se está ejecutando")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass:
                        "inf-alert-blue green-500--text rounded-md mt-2",
                      attrs: { height: 62, dense: "", text: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 my-1" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-900", size: "22" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "body-2",
                                staticStyle: { "line-height": "14px" },
                              },
                              [
                                _vm._v("Esta proceso "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("podría tardar varios minutos")]
                                ),
                                _vm._v(" en completarse. "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      "El estado se actualizará automáticamente "
                                    ),
                                  ]
                                ),
                                _vm._v(" en el documento. "),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDetailAssign,
            callback: function ($$v) {
              _vm.dialogDetailAssign = $$v
            },
            expression: "dialogDetailAssign",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Información de cesión")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogDetailAssign = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _c(
                    "div",
                    { staticClass: "px-5 pb-2" },
                    [
                      _c(
                        "v-list",
                        { staticClass: "v-list-form-main transparent pa-0" },
                        [
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard")]
                                  ),
                                  _vm._v("Estado"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _c("chip-status", {
                                    attrs: {
                                      status:
                                        _vm.instance.assignment_agency_status,
                                      showDetail: true,
                                      isTooltip: false,
                                      type: "assign",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard-search")]
                                  ),
                                  _vm._v("Detalle del estado"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "body-1 align-self-start mt-2",
                                  staticStyle: {
                                    "white-space": "normal !important",
                                  },
                                },
                                [
                                  _vm.instance?.assignment_agency_status_code
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.instance
                                              .assignment_agency_status_code
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 text--disabled font-italic d-block",
                                        },
                                        [_vm._v("Sin definir")]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard-list")]
                                  ),
                                  _vm._v("Track ID"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _vm.instance?.assignment_agency_id
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            color: "grey-background",
                                            right: "",
                                            transition: "scale-transition",
                                            "max-width": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "grey-300--text",
                                                          staticStyle: {
                                                            "justify-content":
                                                              "left",
                                                          },
                                                          attrs: {
                                                            text: "",
                                                            ripple: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toClipboard(
                                                                _vm.instance
                                                                  ?.assignment_agency_id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.instance
                                                              ?.assignment_agency_id
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            43912920
                                          ),
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-block px-3 py-2",
                                            },
                                            [_vm._v("Copiar")]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 text--disabled font-italic d-block",
                                        },
                                        [_vm._v("Sin definir")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-col",
                    { staticClass: "px-6 mb-4" },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                size: "18",
                                left: "",
                                color: "grey-500",
                              },
                            },
                            [_vm._v("mdi-file-arrow-left-right")]
                          ),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold grey-500--text" },
                            [_vm._v("Cedida a")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list",
                        { staticClass: "v-list-form-main transparent pa-0" },
                        [
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "grey-500--text subtitle-2" },
                                [_vm._v("Nombre")]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.instance.assignee_name ||
                                        "Sin definir"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "grey-500--text subtitle-2" },
                                [_vm._v(_vm._s(_vm.$t("generals.RUT")))]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatRut(
                                        _vm.instance.assignee_tax_id
                                      ) || "Sin definir"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "grey-500--text subtitle-2" },
                                [_vm._v("Fecha de cesión")]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateTimeSecond")(
                                        _vm.instance.assignment_date
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDetailAssign = false
                        },
                      },
                    },
                    [_vm._v("Cerrar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }